import { useCallback } from 'react';
import { useAuth } from '@clerk/react';

/** Returns a stable getToken wrapper for BrokerMax API calls (session JWT). */
export function useAccountGetToken() {
  const { getToken } = useAuth();
  return useCallback(() => getToken(), [getToken]);
}
